import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1049f639"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "picture" }
const _hoisted_3 = { class: "d-flex-1f name" }
const _hoisted_4 = { class: "supplies-info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "捐赠时间：", -1))
const _hoisted_6 = { class: "supplies-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "捐赠物资：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "捐赠金额：", -1))
const _hoisted_9 = {
  key: 0,
  class: "donation-flag"
}
const _hoisted_10 = {
  key: 1,
  class: "cert-flag-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "supplies-card donation-card",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goSuppliesDetails && _ctx.goSuppliesDetails(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RatioHeightContainer, { ratio: 100 }, {
          default: _withCtx(() => [
            _createVNode(_component_van_image, {
              width: "100%",
              height: "100%",
              radius: "50%",
              fit: "cover",
              src: _ctx.img(_ctx.data.headUrl)
            }, null, 8, ["src"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.data.userName), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_van_button, {
          class: "d-theme-btn btn",
          color: "#ff8c4c"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.flag), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createTextVNode(_toDisplayString(new Date(_ctx.data.createTimeStamp).format("yyyy-MM-dd HH:mm:ss")), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.data.donationType == 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(_ctx.data.suppliesName), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(_ctx.data.points) + "元", 1)
          ], 64))
    ]),
    (_ctx.data.suppliesDonateStatus == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 已捐出 "))
      : _createCommentVNode("", true),
    (_ctx.data.donationCertificateId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_van_button, {
            plain: "",
            type: "primary",
            hairline: "",
            round: "",
            color: "#fd5c02",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goCert()), ["stop"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看证书>>")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}